import React from "react";
import { Link } from "react-router-dom";

import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import {
  serviceCards,
  processSteps,
  wholesaleAccounts,
  qualityPillars,
} from "../data/siteData";

const SERVICE_IMAGES = [
  "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=1200&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1563213126-a4273aed2016?w=1200&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=1200&auto=format&fit=crop",
];

function Services() {
  return (
    <div className="page-shell">
      <SiteHeader />

      <main>

        {/* ── 1. PAGE HERO ────────────────────────────────────── */}
        <section className="page-hero services-hero">
          <div className="container">
            <nav className="breadcrumb" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span className="breadcrumb-sep">›</span>
              <span className="breadcrumb-current">Services</span>
            </nav>
            <p className="eyebrow">What We Offer</p>
            <h1>Our Services</h1>
            <p className="services-hero-sub">
              Wholesale supply · Parallel imports · OTC lines · Account replenishment
            </p>
          </div>
          <div className="services-hero-bg">
            <img
              src="https://images.unsplash.com/photo-1516549655169-df83a0774514?w=1600&auto=format&fit=crop"
              alt=""
              className="services-hero-img"
            />
            <div className="services-hero-overlay" />
          </div>
        </section>

        {/* ── 2. SERVICES DETAIL — alternating layout ─────────── */}
        <section className="section" style={{ background: "var(--white)" }}>
          <div className="container">
            <div className="section-heading">
              <p className="eyebrow">Service Breakdown</p>
              <h2>Every service, explained in full.</h2>
              <p>
                Each service is designed around the operational needs of trade
                buyers — from first enquiry through to ongoing account support.
              </p>
            </div>

            <div className="services-detail-list">
              {serviceCards.map((service, i) => (
                <article
                  key={service.number}
                  className={`services-detail-row${i % 2 !== 0 ? " services-detail-row-reverse" : ""}`}
                >
                  <div className="services-detail-image-wrap">
                    <img
                      src={SERVICE_IMAGES[i]}
                      alt={service.title}
                      className="services-detail-image"
                    />
                    <span className="services-detail-number">{service.number}</span>
                  </div>

                  <div className="services-detail-copy">
                    <p className="eyebrow">Service {service.number}</p>
                    <h3>{service.title}</h3>
                    <p className="services-detail-lead">{service.text}</p>
                    <p className="services-detail-body">{service.detail}</p>
                    <Link to="/contact" className="btn btn-primary services-detail-cta">
                      Enquire about this service
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ── 3. PROCESS STEPS ────────────────────────────────── */}
        <section className="section section-dark">
          <div className="container">
            <div className="section-heading centered">
              <p className="eyebrow">The Process</p>
              <h2>How we handle every order.</h2>
              <p>
                A structured four-step workflow that takes buyers from initial
                enquiry to confirmed fulfilment and ongoing account support.
              </p>
            </div>

            <div className="services-process-grid">
              {processSteps.map((step, i) => (
                <article key={step.step} className="services-process-card">
                  <div className="services-process-step-wrap">
                    <span className="services-process-step">{step.step}</span>
                    {i < processSteps.length - 1 && (
                      <span className="services-process-line" aria-hidden="true" />
                    )}
                  </div>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ── 4. WHO WE SERVE ─────────────────────────────────── */}
        <section className="section" style={{ background: "var(--white)" }}>
          <div className="container">
            <div className="section-heading centered">
              <p className="eyebrow">Who We Serve</p>
              <h2>Built for professional trade buyers.</h2>
              <p>
                Our wholesale services are structured for organisations that
                need dependable pharmaceutical supply and responsive account
                management.
              </p>
            </div>

            <div className="grid-3 services-accounts-grid">
              {wholesaleAccounts.map((account, i) => (
                <article key={account.customer} className="services-account-card">
                  <span className="services-account-number">0{i + 1}</span>
                  <h3>{account.customer}</h3>
                  <p>{account.note}</p>
                  <Link to="/contact" className="btn btn-ghost services-account-cta">
                    Get in touch →
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ── 5. QUALITY PILLARS ──────────────────────────────── */}
        <section className="section section-grey">
          <div className="container services-quality-grid">

            <div className="services-quality-copy">
              <p className="eyebrow">Quality & Standards</p>
              <h2>Service quality is part of the company promise.</h2>
              <p>
                Every interaction with Etiquette Pharmaceuticals is backed by
                structured workflows, clear communication, and a commitment to
                long-term account relationships.
              </p>
              <Link to="/contact" className="btn btn-primary" style={{ marginTop: "2rem", alignSelf: "flex-start" }}>
                Speak with our team
              </Link>
            </div>

            <ul className="services-quality-list">
              {qualityPillars.map((pillar, i) => (
                <li key={i} className="services-quality-item">
                  <span className="services-quality-index">0{i + 1}</span>
                  <span className="services-quality-text">{pillar}</span>
                </li>
              ))}
            </ul>

          </div>
        </section>

        {/* ── 6. CTA BANNER ───────────────────────────────────── */}
        <section className="section section-green">
          <div className="container cta-banner">
            <p className="eyebrow" style={{ color: "rgba(255,255,255,0.6)" }}>
              Ready to get started?
            </p>
            <h2>Let's build a supply relationship.</h2>
            <p>
              Send us your requirements and we will confirm product
              availability, pricing, and fulfilment timelines within 24 hours.
            </p>
            <div className="btn-group" style={{ justifyContent: "center" }}>
              <Link to="/contact" className="btn btn-outline">
                Request a Quote
              </Link>
              <Link to="/products" className="btn btn-ghost" style={{ color: "rgba(255,255,255,0.8)" }}>
                Browse products →
              </Link>
            </div>
          </div>
        </section>

      </main>

      <SiteFooter />
    </div>
  );
}

export default Services;
